export var TabContent = function (_a) {
    var activeTab = _a.activeTab, value = _a.value, children = _a.children;
    return activeTab === value ? children : null;
};
